import React from 'react';
import { compose, setPropTypes, pure } from 'recompose';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import DetailTextButton from '../atoms/DetailTextButton';
import EditTextButton from '../atoms/EditTextButton';
import DeleteTextButton from '../atoms/DeleteTextButton';
// import ShowHideTextButton from '../atoms/ShowHideTextButton';

const styles = {
  firstTableCell: {
    borderRight: '1px solid #e0e0e0',
    padding: 10
  },
  leftIcon: {
    padding: '0px 5px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      childFoodId: PropTypes.number,
      childFoodName: PropTypes.string,
      menuId: PropTypes.number,
      shopName: PropTypes.string,
      menuName: PropTypes.string,
      childFoodDescription: PropTypes.string,
      //   price: PropTypes.number,
      //   taxType: PropTypes.string,
      image: PropTypes.string,
      updatedAt: PropTypes.string
    })
  ).isRequired
};

const enhance = compose(
  pure,
  setPropTypes(propTypes)
);

const UserTableBody = enhance(
  ({
    list,
    emptyRows,
    page,
    rowsPerPage,
    detailOpenAction,
    editOpenAction,
    deleteOpenAction,
    // showHideOpenAction,
    order,
    orderBy,
    roles
  }) => {
    const sortedResult = _.orderBy(list, orderBy, order);
    const listMenuTypeHideEdit = ['DEFAULT'];
    return (
      <TableBody>
        {sortedResult
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(gochiChildFoodList => {
            const params = {
              id: gochiChildFoodList.childFoodId
              //   showHide: gochiChildFoodList.showHide
            };

            const key = `${gochiChildFoodList.childFoodId}-${
              gochiChildFoodList.shopId
            }-${gochiChildFoodList.groupId}`;
            return (
              <TableRow key={key} hover>
                <TableCell>
                  {!listMenuTypeHideEdit.includes(
                    gochiChildFoodList.menuType
                  ) && (
                    <EditTextButton
                      id={gochiChildFoodList.childFoodId}
                      onClickAction={editOpenAction}
                    />
                  )}
                </TableCell>
                {/* {(roles.isSecretariat || roles.isDeveloper) && (
                  <TableCell>{gochiMenu.shopId}</TableCell>
                )} */}
                <TableCell>{gochiChildFoodList.childFoodId}</TableCell>
                <TableCell>{gochiChildFoodList.childFoodName}</TableCell>
                <TableCell>{gochiChildFoodList.shop.shopName}</TableCell>
                {(roles.isSecretariat || roles.isCreateChildFoodShop) && (
                  <TableCell>{gochiChildFoodList.group.groupName}</TableCell>
                )}
                <TableCell>
                  {gochiChildFoodList.group &&
                  gochiChildFoodList.group.menu &&
                  gochiChildFoodList.group.menu.menuId
                    ? gochiChildFoodList.group.menu.menuId
                    : '未登録'}
                </TableCell>
                <TableCell>
                  <DetailTextButton
                    params={params}
                    onClickAction={detailOpenAction}
                  />
                </TableCell>
                <TableCell>
                  {!roles.isShop && !roles.isGroup && (
                    <DeleteTextButton
                      id={gochiChildFoodList.childFoodId}
                      onClickAction={deleteOpenAction}
                    />
                  )}
                </TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={7} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(UserTableBody);
